var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUoEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 63,
    viewBox: "0 0 80 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.2648 23.0323C41.3836 23.0614 36.4267 22.8342 31.7901 21.5469C27.1536 20.2596 23.0529 17.8307 19.325 14.994C16.8844 13.1476 14.6652 11.6797 11.4965 11.901C8.39828 12.0639 5.43482 13.2199 3.04468 15.1979C-0.986086 18.7277 -0.37448 25.2515 1.23317 29.8415C3.65629 36.7555 11.0305 41.5552 17.2922 44.6831C24.5324 48.3003 32.4833 50.403 40.4575 51.6088C47.4472 52.6689 56.4233 53.4436 62.4752 48.8769C68.0379 44.6889 69.564 35.1129 68.201 28.6474C67.8693 26.7377 66.8524 25.0146 65.341 23.8011C61.4326 20.947 55.6078 22.8517 51.2159 22.9507C49.6141 22.9857 47.9307 23.0264 46.2648 23.0323Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4644 0.424988V2.92966",
    stroke: "#CED4DA",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2124 1.67639H23.7171",
    stroke: "#CED4DA",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9834 50.35V52.8546",
    stroke: "#CED4DA",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.731 51.6014H71.2356",
    stroke: "#CED4DA",
    strokeWidth: 0.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.54004 38.8909C3.57895 38.8912 3.61035 38.9233 3.61035 38.9622C3.6101 39.001 3.57879 39.0323 3.54004 39.0325C3.50108 39.0325 3.469 39.0011 3.46875 38.9622C3.46875 38.9231 3.50092 38.8909 3.54004 38.8909Z",
    fill: "#CED4DA",
    stroke: "#CED4DA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1426 2.36755C52.1815 2.3678 52.2129 2.39988 52.2129 2.43884C52.2126 2.4776 52.1813 2.50891 52.1426 2.50916C52.1036 2.50916 52.0715 2.47775 52.0713 2.43884C52.0713 2.39972 52.1035 2.36755 52.1426 2.36755Z",
    fill: "#CED4DA",
    stroke: "#CED4DA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3219 62.931C48.1281 62.931 57.6989 62.3364 57.6989 61.603C57.6989 60.8695 48.1281 60.2749 36.3219 60.2749C24.5157 60.2749 14.9448 60.8695 14.9448 61.603C14.9448 62.3364 24.5157 62.931 36.3219 62.931Z",
    fill: "#F1F5F9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8551 7.22821H50.9014C51.6738 7.22821 52.4146 7.53505 52.9607 8.08123C53.5069 8.62742 53.8138 9.3682 53.8138 10.1406V47.0757C53.8138 47.8482 53.5069 48.589 52.9607 49.1351C52.4146 49.6813 51.6738 49.9882 50.9014 49.9882H15.8768C15.1043 49.9882 14.3636 49.6813 13.8174 49.1351C13.2712 48.589 12.9644 47.8482 12.9644 47.0757V14.1889L19.8551 7.22821Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6738 25.226H21.6606V50.3425H53.6738V25.226Z",
    fill: "#CBD5E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9644 14.1889H18.6086C18.9397 14.1873 19.2568 14.0547 19.4904 13.82C19.724 13.5853 19.8551 13.2677 19.8551 12.9365V7.22821L12.9644 14.1889Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5166 17.2077H21.853C20.6209 17.2077 19.6221 18.2065 19.6221 19.4386V26.2129C19.6221 27.445 20.6209 28.4438 21.853 28.4438H53.5166C54.7487 28.4438 55.7476 27.445 55.7476 26.2129V19.4386C55.7476 18.2065 54.7487 17.2077 53.5166 17.2077Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7731 24.7847C26.8476 24.7847 27.7186 23.9137 27.7186 22.8392C27.7186 21.7648 26.8476 20.8937 25.7731 20.8937C24.6987 20.8937 23.8276 21.7648 23.8276 22.8392C23.8276 23.9137 24.6987 24.7847 25.7731 24.7847Z",
    fill: "#CBD5E1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8893 24.7847C32.9638 24.7847 33.8348 23.9137 33.8348 22.8392C33.8348 21.7648 32.9638 20.8937 31.8893 20.8937C30.8149 20.8937 29.9438 21.7648 29.9438 22.8392C29.9438 23.9137 30.8149 24.7847 31.8893 24.7847Z",
    fill: "#CBD5E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9992 24.7847C39.0737 24.7847 39.9447 23.9137 39.9447 22.8392C39.9447 21.7648 39.0737 20.8937 37.9992 20.8937C36.9247 20.8937 36.0537 21.7648 36.0537 22.8392C36.0537 23.9137 36.9247 24.7847 37.9992 24.7847Z",
    fill: "#CBD5E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5166 29.6583H21.853C20.6209 29.6583 19.6221 30.6571 19.6221 31.8892V38.6634C19.6221 39.8955 20.6209 40.8943 21.853 40.8943H53.5166C54.7487 40.8943 55.7476 39.8955 55.7476 38.6634V31.8892C55.7476 30.6571 54.7487 29.6583 53.5166 29.6583Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7731 37.2444C26.8476 37.2444 27.7186 36.3733 27.7186 35.2989C27.7186 34.2244 26.8476 33.3534 25.7731 33.3534C24.6987 33.3534 23.8276 34.2244 23.8276 35.2989C23.8276 36.3733 24.6987 37.2444 25.7731 37.2444Z",
    fill: "#CBD5E1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8893 37.2444C32.9638 37.2444 33.8348 36.3733 33.8348 35.2989C33.8348 34.2244 32.9638 33.3534 31.8893 33.3534C30.8149 33.3534 29.9438 34.2244 29.9438 35.2989C29.9438 36.3733 30.8149 37.2444 31.8893 37.2444Z",
    fill: "#CBD5E1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9992 37.2444C39.0737 37.2444 39.9447 36.3733 39.9447 35.2989C39.9447 34.2244 39.0737 33.3534 37.9992 33.3534C36.9247 33.3534 36.0537 34.2244 36.0537 35.2989C36.0537 36.3733 36.9247 37.2444 37.9992 37.2444Z",
    fill: "#CBD5E1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5166 42.1179H21.853C20.6209 42.1179 19.6221 43.1167 19.6221 44.3488V51.1231C19.6221 52.3552 20.6209 53.354 21.853 53.354H53.5166C54.7487 53.354 55.7476 52.3552 55.7476 51.1231V44.3488C55.7476 43.1167 54.7487 42.1179 53.5166 42.1179Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7731 49.6949C26.8476 49.6949 27.7186 48.8238 27.7186 47.7494C27.7186 46.6749 26.8476 45.8039 25.7731 45.8039C24.6987 45.8039 23.8276 46.6749 23.8276 47.7494C23.8276 48.8238 24.6987 49.6949 25.7731 49.6949Z",
    fill: "#CBD5E1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8893 49.6949C32.9638 49.6949 33.8348 48.8238 33.8348 47.7494C33.8348 46.6749 32.9638 45.8039 31.8893 45.8039C30.8149 45.8039 29.9438 46.6749 29.9438 47.7494C29.9438 48.8238 30.8149 49.6949 31.8893 49.6949Z",
    fill: "#CBD5E1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9992 49.6949C39.0737 49.6949 39.9447 48.8238 39.9447 47.7494C39.9447 46.6749 39.0737 45.8039 37.9992 45.8039C36.9247 45.8039 36.0537 46.6749 36.0537 47.7494C36.0537 48.8238 36.9247 49.6949 37.9992 49.6949Z",
    fill: "#CBD5E1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3825 31.3961C63.0512 31.3961 68.4573 25.99 68.4573 19.3212C68.4573 12.6525 63.0512 7.2464 56.3825 7.2464C49.7137 7.2464 44.3076 12.6525 44.3076 19.3212C44.3076 25.99 49.7137 31.3961 56.3825 31.3961Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9565 28.0792L68.1718 31.2945",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8127 29.734L66.8145 30.7782C66.3655 31.2479 66.3823 31.9927 66.852 32.4417L75.5255 40.7332C75.9952 41.1822 76.74 41.1655 77.189 40.6957L78.1872 39.6515C78.6363 39.1818 78.6195 38.437 78.1498 37.988L69.4763 29.6965C69.0065 29.2475 68.2617 29.2642 67.8127 29.734Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUoEmpty);
export default ForwardRef;